module.exports = "/_next/static/images/wrench-duotone-d093f95cf5d02d2f27d2ddfa3b954ce9.svg";